import { DRAFT } from '../../../constants/draft.constants';

import { InputsGenerator } from '../../UI/InputsGenerator';
import { SimpleDialog } from '../../UI/SimpleDialog';

interface ArticleSourcesProps {
  isSourcesModalOpen: boolean;
  handleCloseSourcesModal: () => Promise<void>;
  onSubmitArticleSources: () => void;
  handleInputChange: (index: number, value: string) => void;
  articleSourcesArray: string[];
  errors: (string | null)[];
  handleBlur: (index: number, e: any) => void;
}

export const ArticleSources = (props: ArticleSourcesProps) => {
  const {
    isSourcesModalOpen,
    handleCloseSourcesModal,
    onSubmitArticleSources,
    handleInputChange,
    articleSourcesArray,
    errors,
    handleBlur,
  } = props;

  const dialogBody = (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      className={'STORY__SOURCES__CONTENT'}
    >
      <div>{DRAFT.ADD_SOURCES_DIALOG.MESSAGE}</div>
      <InputsGenerator
        count={DRAFT.ADD_SOURCES_DIALOG.MAX_SOURCES}
        placeholder={DRAFT.ADD_SOURCES_DIALOG.PLACEHOLDER}
        variant={'standard'}
        values={articleSourcesArray}
        onChange={handleInputChange}
        errors={errors}
        onBlur={handleBlur}
        showHelperText={true}
      />
    </div>
  );

  return (
    <SimpleDialog
      open={isSourcesModalOpen}
      onClose={handleCloseSourcesModal}
      onSubmit={onSubmitArticleSources}
      dialogBody={dialogBody}
      className={'STORY__SOURCES__DIALOG'}
      dialogTitle={DRAFT.ADD_SOURCES_DIALOG.TITLE}
      actionLabel={DRAFT.ADD_SOURCES_DIALOG.ADD}
      closeModalLabel={DRAFT.ADD_SOURCES_DIALOG.CLOSE}
    />
  );
};
